import styled from 'styled-components';

import { BaseAngleBracket } from '../../svg';
import { colors } from '../../constants';

interface IProps {
    margin?: string;
    rotate?: number;
    fill?: string;
}

export const Arrow = styled(BaseAngleBracket)<IProps>`
    width: 15px;
    height: 15px;
    margin: ${({ margin }) => margin || 0};
    transform: ${({ rotate }) =>
        rotate ? `rotate(${rotate}deg)` : 'rotate(0deg)'};

    use {
        fill: ${({ fill }) => fill || colors.white};
    }
`;
